import React from 'react';
import './TopBanner.css';

function TopBanner({ title, variant = 'alert', children, testId }) {
    return (
        <div className="top-banner" data-variant={variant} data-testid={testId}>
            <p className="top-banner-title">{title}</p>
            {children}
        </div>
    );
}

export default TopBanner;